module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/mission-white-bg-11fdea209e652c8de6115ad04f3f3f62.png";